export default "__VITE_ASSET__$Vwea85q__"